import { render } from "./Menu.vue?vue&type=template&id=6089acb3&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/gasoil_files/gasoil/docker/boletiland/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6089acb3"]])

export default __exports__